module.exports = __webpack_public_path__ + "img/sixpackcarrier04.a684cf10.jpg";